import styled from 'styled-components';

export const SearchBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  min-height: 140px;
  padding: 20px 20px 12px;
  margin: ${({ noMargin }) => (noMargin ? '0' : '0 0 8px')};
  position: relative;
  border-radius: 16px;
  border: 1px solid var(--line);
  background: var(--card-bg);
  box-shadow: 0 4px 24px rgba(0, 43, 92, 0.06);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus-within {
    border-color: rgba(10, 77, 162, 0.35);
    box-shadow: 0 4px 24px rgba(10, 77, 162, 0.1);
  }

  .main-search {
    width: 100%;
    padding: 0 0 12px;
    margin: 0 0 8px;
    font-size: 16px;
    line-height: 22px;
    height: auto;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid var(--line);
    box-shadow: none;
    outline: none;
    background: none;
  }
`;

export const SearchItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  line-height: 20px;
  color: var(--ink);

  .item-box.open-up .auto-dropdown,
  .item-box.open-up .web-dropdown {
    bottom: 100%;
    top: auto;
    margin-bottom: 8px;
  }

  .item-box.open-down .auto-dropdown,
  .item-box.open-down .web-dropdown {
    top: 100%;
    bottom: auto;
    margin-top: 8px;
  }

  .wrap {
    display: flex;
    align-items: center;
    flex-grow: 1;
    gap: 6px;
    flex-wrap: wrap;
  }

  .item-box {
    @media screen and (min-width: 768px) {
      position: relative;
    }

    &.active {
      .auto-dropdown,
      .web-dropdown {
        display: block;
      }

      .btn {
        background: var(--primary-50);
        border-color: rgba(10, 77, 162, 0.25);
        color: var(--blue);
      }
    }

    .btn {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 7px 10px;
      border-radius: 8px;
      font-size: 14px;
      line-height: 18px;
      font-weight: 500;
      border: 1px solid var(--line);
      background: var(--gray-50);
      color: var(--text-color);
      transition: all 0.2s ease;

      img {
        border-radius: 4px;
        filter: var(--icon-muted-filter);
        opacity: 0.9;
      }

      &:hover {
        border-color: var(--blue);
        background: var(--primary-50);
        color: var(--blue);
      }
    }
  }

  .auto-dropdown,
  .web-dropdown {
    display: none;
    text-align: left;
    width: 343px;
    min-height: 250px;
    position: absolute;
    top: 100%;
    left: 0;
    padding: 12px 16px 16px;
    border-radius: 14px;
    border: 1px solid var(--line);
    box-shadow: 0 12px 40px rgba(0, 43, 92, 0.12);
    background: var(--card-bg);
    z-index: 99;

    @media screen and (min-width: 768px) {
      width: 390px;
      left: 0;
    }

    .subtitle {
      display: block;
      font-size: 11px;
      line-height: 14px;
      font-weight: 700;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: var(--text-color-50);
      margin: 8px 0;
    }

    .list {
      list-style: none;
      font-size: 14px;
      line-height: 18px;
      margin: 0 0 10px;

      li {
        padding: 12px;
        cursor: pointer;
        border-radius: 10px;
        border-bottom: none;

        &:hover {
          background: var(--gray-50);
        }
      }

      .head {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 0 0 8px;

        .icon img {
          filter: var(--icon-muted-filter);
          opacity: 0.9;
        }

        .title {
          display: block;
          font-size: 16px;
          line-height: 20px;
          font-weight: 600;
          text-transform: capitalize;
        }

        .tag {
          display: inline-block;
          font-size: 11px;
          line-height: 14px;
          font-weight: 700;
          padding: 2px 8px;
          border-radius: 999px;
          border: 1px solid rgba(10, 77, 162, 0.2);
          background: var(--primary-50);
          color: var(--blue);
        }
      }
    }

    .agent-list-wrapper {
      max-height: 200px;
      overflow-y: auto;
      padding-right: 4px;
    }

    .custom-agent {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 8px;
      margin: 0 0 4px;
      border-radius: 8px;
      cursor: pointer;
      transition: background 0.15s ease;

      &:hover {
        background: var(--gray-50);
      }

      &.active {
        background: var(--primary-50);
      }

      .icon-box {
        width: 32px;
        height: 32px;
        padding: 4px;
        border-radius: 8px;
        background: var(--primary-50);
        overflow: hidden;

        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 4px;
        }
      }

      .title {
        display: block;
        font-size: 15px;
        line-height: 20px;
        font-weight: 600;
        text-transform: capitalize;
      }
    }

    .recent-search {
      width: 100%;
      position: relative;

      .recent-search-box {
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 8px;
        padding: 8px;
        border-radius: 8px;
        cursor: pointer;
        transition: background 0.15s ease;

        &:hover {
          background: var(--gray-50);
        }

        .icon-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          border-radius: 8px;
          background: var(--primary-50);
        }

        .title {
          display: block;
          font-size: 15px;
          line-height: 20px;
          font-weight: 600;
        }

        .arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 8px;
          font-size: 18px;
          line-height: 1;
          color: var(--text-color-50);
        }
      }
    }

    .advance-btn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      margin-top: 16px;
      padding: 8px;
      border-radius: 8px;
      color: var(--text-color-50);
      transition: background 0.15s ease;

      &:hover {
        background: var(--gray-50);
        color: var(--blue);
      }

      .title {
        display: block;
        font-size: 13px;
        line-height: 18px;
        font-weight: 500;
      }

      .arrow {
        font-size: 16px;
        line-height: 1;
      }
    }

    .btn-check {
      position: absolute;
      top: 16px;
      right: 10px;
      width: 45px;
      height: 26px;
      cursor: pointer;
      border-radius: 50px;
      background: var(--gray-100);

      &.checked {
        background: var(--blue);

        &::before {
          left: 21px;
        }
      }

      &::before {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        width: 22px;
        height: 22px;
        transition: all ease-in-out 0.3s;
        border-radius: 50px;
        background: white;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
      }
    }
  }

  .web-dropdown {
    min-height: auto;
  }

  .mic-btn-wrap {
    display: flex;
    align-items: center;
    gap: 6px;

    .mic-btn,
    .enter-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 38px;
      height: 36px;
      padding: 4px;
      border-radius: 10px;
      border: 1px solid var(--line);
      background: var(--gray-50);
      transition: all 0.2s ease;

      &:hover {
        border-color: var(--blue);
        background: var(--primary-50);
      }
    }

    .mic-btn img {
      filter: var(--icon-muted-filter);
      opacity: 0.9;
    }

    .enter-btn {
      background: var(--blue);
      border-color: var(--blue);

      &:hover {
        background: var(--primary-hover);
        border-color: var(--primary-hover);
      }

      img {
        filter: brightness(0) invert(1);
      }
    }
  }
`;
